import { useState, useEffect } from 'react';
import { 
  collection, 
  addDoc, 
  query, 
  orderBy, 
  serverTimestamp,
  onSnapshot as firestoreOnSnapshot
} from 'firebase/firestore';
import { db } from '../firebase-config';

export default function useChatMessages(lobbyId, currentUser) {
  const [messages, setMessages] = useState([]);
  const [chatMessage, setChatMessage] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!lobbyId) return;

    try {
      const messagesRef = collection(db, `game_sessions/${lobbyId}/messages`);
      const messagesQuery = query(messagesRef, orderBy('timestamp', 'asc'));

      const unsubscribe = firestoreOnSnapshot(messagesQuery, (snapshot) => {
        const newMessages = snapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            ...data,
            formattedTime: data.timestamp?.toDate ? data.timestamp.toDate().toLocaleTimeString('de-DE', {
              hour: '2-digit',
              minute: '2-digit'
            }) : ''
          };
        });
        setMessages(newMessages);
      }, (error) => {
        console.error('Chat Fehler:', error);
        setError('Fehler beim Laden der Nachrichten');
      });

      return () => {
        if (unsubscribe) {
          unsubscribe();
        }
      };
    } catch (error) {
      console.error('Fehler beim Einrichten des Chat-Listeners:', error);
      setError('Fehler beim Einrichten des Chats');
    }
  }, [lobbyId]);

  const sendMessage = async (e) => {
    e?.preventDefault();
    if (!chatMessage.trim() || !currentUser) return;

    try {
      const messagesRef = collection(db, `game_sessions/${lobbyId}/messages`);
      await addDoc(messagesRef, {
        text: chatMessage.trim(),
        userId: currentUser.uid,
        displayName: currentUser.displayName || 'Unbekannter Benutzer',
        photoURL: currentUser.photoURL,
        hasRpmAvatar: currentUser.hasRpmAvatar || false,
        rpmModelUrl: currentUser.rpmModelUrl || null,
        rpmAvatarConfig: currentUser.rpmAvatarConfig || null,
        rpmAvatarType: currentUser.rpmAvatarType || null,
        timestamp: serverTimestamp()
      });
      setChatMessage('');
    } catch (error) {
      console.error('Fehler beim Senden der Nachricht:', error);
      setError('Fehler beim Senden der Nachricht');
    }
  };

  const sendGif = async (gifUrl) => {
    if (!gifUrl || !currentUser) return;

    try {
      const messagesRef = collection(db, `game_sessions/${lobbyId}/messages`);
      await addDoc(messagesRef, {
        gifUrl,
        userId: currentUser.uid,
        displayName: currentUser.displayName || 'Unbekannter Benutzer',
        photoURL: currentUser.photoURL,
        hasRpmAvatar: currentUser.hasRpmAvatar || false,
        rpmModelUrl: currentUser.rpmModelUrl || null,
        rpmAvatarConfig: currentUser.rpmAvatarConfig || null,
        rpmAvatarType: currentUser.rpmAvatarType || null,
        timestamp: serverTimestamp()
      });
    } catch (error) {
      console.error('Fehler beim Senden des GIFs:', error);
      setError('Fehler beim Senden des GIFs');
    }
  };

  return {
    messages,
    chatMessage,
    setChatMessage,
    sendMessage,
    sendGif,
    error
  };
} 